<template name="fade">
  <div id="preload-screen">
    <div class="text-center container" v-if="show">
      <div class="spinnerdes">
        <div class="dot1"></div>
        <div class="dot2"></div>
      </div>
      <div class="shadow"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "preloader",
  data() {
    return {
      show: true,
    };
  },

  components: {},

  mounted() {
    this.showToggle();
  },
  methods: {
    showToggle() {
      setTimeout(() => {
        this.show = false;
      }, 3000);
    },
  },
};
</script>

<style scoped>
/* loading animation */
.text-center {
  z-index: 1012;
  max-width: 100vw;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow-x: scroll;
}
.shadow {
  background: #fff;
  z-index: 1011;
  width: 100%;
  height: 100%;
  opacity: 1;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
}
.spinnerdes {
  z-index: 1012;
  margin: 0;
  width: 40px;
  height: 40px;
  align-items: center;
  display: inline-block;
  justify-content: center;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-animation: sk-rotate 2s infinite linear;
  animation: sk-rotate 2s infinite linear;
}
.dot1,
.dot2 {
  width: 60%;
  height: 60%;
  display: inline-block;
  position: absolute;
  top: 0;
  background-color: #005a06;
  border-radius: 100%;

  -webkit-animation: sk-bounce 2s infinite ease-in-out;
  animation: sk-bounce 2s infinite ease-in-out;
}

.dot2 {
  top: auto;
  bottom: 0;
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

@-webkit-keyframes sk-rotate {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes sk-rotate {
  100% {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}

@-webkit-keyframes sk-bounce {
  0%,
  100% {
    -webkit-transform: scale(0);
  }
  50% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bounce {
  0%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
@media (max-width: 683px) {
  .spinnerdes {
    align-items: center;
    display: inline-block;
    justify-content: center;
    position: absolute;
    left: 45%;
    top: 50%;
  }
}
</style>